export const deliveryOptionHasTaxPrice = deliveryOption => deliveryOption?.taxPrice?.value > 0;
export const namedDayHasTaxPrice = namedDay => namedDay?.taxPrice?.value > 0;
export const deliveryOptionHasNamedDayOptions = deliveryOption => deliveryOption?.deliverableDates?.length > 0;
export const isResidentIdRequired = deliveryOption => deliveryOption?.residentIdRequired
  || deliveryOptionHasTaxPrice(deliveryOption);

export const doDeliveryOptionsIncludeTaxableOption = deliveryOptions => deliveryOptions.some(deliveryOptionHasTaxPrice);

export const doDeloptsIncludeResidentIDRequiredOption = deliveryOptions => deliveryOptions.some(isResidentIdRequired);

export const getSelectedOptionOrSubOption = deliveryOption => (deliveryOptionHasNamedDayOptions(deliveryOption) ? deliveryOption.deliverableDates[deliveryOption.selectedDeliverableDateIndex] : deliveryOption);
